/* Florage – generische Klaviyo Client-Subscribe-Anbindung (Double-Opt-In über die Liste).
   Bindet an jedes Formular mit [data-kv-form]. Vorname optional. 202 = Erfolg. */
(function () {
  'use strict';
  var RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function init(scope) {
    (scope || document).querySelectorAll('[data-kv-form]').forEach(function (form) {
      if (form.__kv) return; form.__kv = 1;
      var wrap = form.closest('[data-kv]') || form.parentNode;
      var done = wrap.querySelector('[data-kv-done]');
      var emailEl = form.querySelector('[data-kv-email]');
      var nameEl = form.querySelector('[data-kv-name]');
      var err = form.querySelector('[data-kv-err]');
      var btn = form.querySelector('[data-kv-submit]');
      var btnText = form.querySelector('[data-kv-btn-text]');
      var btnLoad = form.querySelector('[data-kv-btn-loading]');
      var key = form.getAttribute('data-kv-key');
      var list = form.getAttribute('data-kv-list');
      var source = form.getAttribute('data-kv-source') || '';
      var STORE = 'fl-kv-' + (list || 'sub');

      function show(returning) {
        if (!done) return;
        form.hidden = true; done.hidden = false;
        if (returning) {
          var h = done.querySelector('[data-kv-done-h]');
          if (h) h.textContent = 'Du bist schon dabei – danke!';
        }
      }
      function showErr(msg) { if (err) { err.textContent = msg; err.hidden = false; } }
      function loading(on) { if (btn) btn.disabled = on; if (btnText) btnText.hidden = on; if (btnLoad) btnLoad.hidden = !on; }

      try { if (localStorage.getItem(STORE)) show(true); } catch (e) {}
      if (emailEl) emailEl.addEventListener('input', function () { if (err) err.hidden = true; emailEl.classList.remove('is-invalid'); });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (emailEl && emailEl.value || '').trim();
        var firstName = (nameEl && nameEl.value || '').trim();
        if (!RE.test(email)) { showErr('Bitte gib eine gültige E-Mail-Adresse ein.'); if (emailEl) emailEl.classList.add('is-invalid'); return; }
        if (!key || !list) { showErr('Newsletter ist noch nicht konfiguriert.'); return; }
        loading(true);
        var REV = '2024-10-15';
        var QS = '?company_id=' + encodeURIComponent(key);
        function kvMsg(d) { var m = 'Ups, etwas ist schiefgelaufen. Versuch es bitte noch einmal.'; try { if (d && d.errors && d.errors[0] && d.errors[0].detail) m = d.errors[0].detail; } catch (e2) {} return m; }
        /* Schritt 1: Profil mit Eigenschaften (+ optional Vorname) anlegen/aktualisieren.
           first_name & properties akzeptiert NUR der Profiles-Endpoint, nicht der Subscriptions-Endpoint. */
        var profAttrs = { email: email, properties: { signup_source: source, signup_date: new Date().toISOString() } };
        if (firstName) profAttrs.first_name = firstName;
        var profilePayload = { data: { type: 'profile', attributes: profAttrs } };
        /* Schritt 2: Zur Liste anmelden. Profil-Attribute hier NUR email (garantiert gueltig).
           Ohne subscriptions-Objekt defaultet Klaviyo auf MARKETING und loest das Double-Opt-In aus. */
        var subPayload = { data: { type: 'subscription', attributes: {
          custom_source: source,
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }, relationships: { list: { data: { type: 'list', id: list } } } } };
        fetch('https://a.klaviyo.com/client/profiles/' + QS, {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': REV }, body: JSON.stringify(profilePayload)
        }).then(function (pr) {
          /* 2xx = neu angelegt, 409 = Profil existiert bereits – in beiden Faellen weiter abonnieren. */
          if (!pr.ok && pr.status !== 409) { return pr.json().then(function (d) { loading(false); showErr(kvMsg(d)); throw 0; }); }
          return fetch('https://a.klaviyo.com/client/subscriptions/' + QS, {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': REV }, body: JSON.stringify(subPayload)
          });
        }).then(function (sr) {
          if (!sr) return;
          if (sr.status === 202) {
            try { localStorage.setItem(STORE, email); } catch (er) {}
            loading(false); show(false); return;
          }
          sr.json().then(function (d) { loading(false); showErr(kvMsg(d)); }).catch(function () { loading(false); showErr('Ups, etwas ist schiefgelaufen. Versuch es bitte noch einmal.'); });
        }).catch(function (e2) { if (e2 === 0) return; loading(false); showErr('Verbindungsfehler. Bitte versuch es noch einmal.'); });
      });
    });
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () { init(document); });
})();
